import { Category } from '@repo/types';
import c from 'classnames';
import { Icon } from 'components';
import { useEffect, useState } from 'react';
import { categoryAnchorId } from 'views/Results/utils/categoriesAndMetrics';
import CategoriesList from '../MetricsNavigation/CategoriesList';
import NavigationRow from '../MetricsNavigation/NavigationRow';
import styles from './MetricsCategorySelector.module.css';

type MetricsCategorySelectorProps = {
  categories: Category[];
  activeId?: string;
};

export default function MetricsCategorySelector({
  categories,
  activeId,
}: MetricsCategorySelectorProps) {
  const [selectedCategory, setSelectedCategory] = useState<Category>(
    categories[0],
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    setSelectedCategory(
      prev => categories.find(c => categoryAnchorId(c) === activeId) ?? prev,
    );
  }, [activeId, categories]);

  if (!selectedCategory) return null;

  function handleSelect(category: Category) {
    setSelectedCategory(category);
    setIsDropdownOpen(false);
  }

  function handleOpenDropdown(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e.preventDefault();
    setIsDropdownOpen(prev => !prev);
  }

  function handleBlur() {
    setTimeout(() => setIsDropdownOpen(false), 100);
  }

  return (
    <div onBlur={handleBlur} className={c(styles.container, 'hide-on-desktop')}>
      <div
        onClick={handleOpenDropdown}
        className={c(styles.selectedOption, isDropdownOpen && styles.opened)}
      >
        <NavigationRow
          category={selectedCategory}
          isActive={false}
          isDropdownSelectedOption
          isDropdown
        />
        <Icon name='chevronDown' className={styles.icon} />
      </div>
      {isDropdownOpen && (
        <div className={styles.dropdown}>
          <CategoriesList
            categories={categories}
            onClick={handleSelect}
            activeId={activeId}
            isDropdown
          />
        </div>
      )}
    </div>
  );
}
